<template>
  <div>
    <vs-row class="mb-4">
      <vs-col>
        <h5>
          <i class="dot"></i>{{ $t('증상조사 대상자 정보') }}</h5>
      </vs-col>
    </vs-row>
    <div
      class="grid flex-wrap"
      :style="{
        'grid-template-columns': isMobile ? '1fr' : '1fr 1fr 1fr',
        'column-gap': '1.5rem'
      }"
    >

      <!-- 성명 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('성명') }}</vs-col>
        <vs-col>
          <div v-if="isPrint" class="print-input">{{ form.name }}</div>
          <ml-input v-else class="w-full" v-model="form.name" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 연령 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('연령') }}</vs-col>
        <vs-col class="grid" style="grid-template-columns: auto 1fr auto" vs-align="center">
          <span class="title mr-2">만</span>
          <div v-if="isPrint" class="print-input text-right" >{{ form.age }}</div>
          <ml-input v-else class="w-full" v-model="form.age" :readonly="readonly" />
          <span class="title ml-2">세</span>
        </vs-col>
      </vs-row>

      <!-- 성별 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('성별') }}</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right">{{ form.gender }}</div>
          <div v-else>
            <vs-radio class="mr-4" v-model="form.gender" vs-value="남" color="secondary" :disabled="readonly">남</vs-radio>
            <vs-radio v-model="form.gender" vs-value="여" color="secondary" :disabled="readonly">여</vs-radio>
          </div>
        </vs-col>
      </vs-row>

      <!-- 현 직장경력 (~년/개월) -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('현 직장경력') }}<br>(~년/개월)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.workExperience }}</div>
          <ml-input v-else class="w-full" v-model="form.workExperience" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 작업부서 (~부/라인) -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('작업부서') }}<br>(~부/라인)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.workDepartment }}</div>
          <ml-input v-else class="w-full" v-model="form.workDepartment" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 작업(수행작업) -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('작업(수행작업)') }}</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.workPerform }}</div>
          <ml-input v-else class="w-full" v-model="form.workPerform" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 결혼여부 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('결혼여부') }}</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.marriage }}</div>
          <div v-else>
            <vs-radio class="mr-4" v-model="form.marriage" vs-value="미혼" color="secondary" :disabled="readonly">{{ $t('미혼') }}</vs-radio>
            <vs-radio v-model="form.marriage" vs-value="기혼" color="secondary" :disabled="readonly">{{ $t('기혼') }}</vs-radio>
          </div>
        </vs-col>
      </vs-row>
      <div></div>
      <div></div>

      <!-- 현재하고 있는 작업(구체적으로) -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('현재하고 있는 작업') }}<br>(구체적으로)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.currentWork }}</div>
          <ml-input v-else class="w-full" v-model="form.currentWork" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 현재하고 있는 작업: 작업시간 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('현재하고 있는 작업') }}<br>(구체적으로)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.currentPeriod1 }}
            <span class="px-2">년</span>
            {{ form.currentPeriod2 }}
            <span class="pl-2">{{ $t('개월째 하고 있음') }}</span>
          </div>
          <div v-else class="w-full grid" :style="{
            'grid-template-columns': isMobile ? '1fr auto 1fr auto' : '1fr auto 1fr auto',
            'align-items': 'center'
          }" >
            <ml-input class="w-full" v-model="form.currentPeriod1" :readonly="readonly" />
            <span class="px-2">년</span>
            <ml-input class="w-full" v-model="form.currentPeriod2" :readonly="readonly" />
            <span class="pl-2">{{ $t('개월째 하고 있음') }}</span>
          </div>
        </vs-col>
      </vs-row>
      <div></div>

      <!-- 1일 근무시간 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('1일 근무시간') }}</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.dayWorkTime }}</div>
          <ml-input v-else class="w-full" v-model="form.dayWorkTime" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 근무 중 휴식시간(식사시간 제외) -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('근무 중 휴식시간') }}<br>(식사시간 제외)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.dayRestTime1 }}
            <span class="px-2">{{ $t('분씩') }}</span>
            {{ form.dayRestTime2 }}
            <span class="pl-2">{{ $t('회 휴식') }}</span>
          </div>
          <div v-else class="w-full grid" :style="{
            'grid-template-columns': isMobile ? '1fr auto 1fr auto' : '1fr auto 1fr auto',
            'align-items': 'center'
          }" >
            <ml-input class="w-full" v-model="form.dayRestTime1" :readonly="readonly" />
            <span class="px-2">{{ $t('분씩') }}</span>
            <ml-input class="w-full" v-model="form.dayRestTime2" :readonly="readonly" />
            <span class="pl-2">{{ $t('회 휴식') }}</span>
          </div>
        </vs-col>
      </vs-row>
      <div></div>

      <!-- 현작업을 하기 전에 했던 작업 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('현작업을 하기 전에') }}<br>했던 작업</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.prevWork }}</div>
          <ml-input v-else class="w-full" v-model="form.prevWork" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 현재하고 있는 작업: 작업시간 -->
      <vs-row class="mb-4" :style="{ 'display': 'grid', 'grid-template-columns': isMobile ? '110px 1fr' : '128px 1fr' }" vs-align="center">
        <vs-col class="title">{{ $t('현재하고 있는 작업') }}<br>(구체적으로)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.prevPeriod1 }}
            <span class="px-2">년</span>
            {{ form.prevPeriod2 }}
            <span class="pl-2">{{ $t('개월째 하고 있음') }}</span>
          </div>
          <div v-else class="w-full grid" :style="{
            'grid-template-columns': isMobile ? '1fr auto 1fr auto' : '1fr auto 1fr auto',
            'align-items': 'center'
          }" >
            <ml-input class="w-full" v-model="form.prevPeriod1" :readonly="readonly" />
            <span class="px-2">년</span>
            <ml-input class="w-full" v-model="form.prevPeriod2" :readonly="readonly" />
            <span class="pl-2">{{ $t('개월째 하고 있음') }}</span>
          </div>
        </vs-col>
      </vs-row>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MusculoskeletalSymptomsSurveyTable',
  props: {
    isPrint: Boolean,
    value: Object,
    readonly: Boolean,
  },
  computed: {
    isMobile() {
      return this.$viewport.isMobile;
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler() {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.$emit("input", this.form);
      },
    },
  },
  data () {
    return {
      form: {
        name: '', //이름
        age: '', //나이
        gender: '남', //성별
        workExperience: '', //현 직장경력 (~년/개월)
        workDepartment: '', //작업부서 (~부/라인)
        workPerform: '', //작업(수행작업)
        marriage: '미혼', //결혼여부
        currentWork: '', //현재하고 있는 작업
        currentPeriod1: '',
        currentPeriod2: '',
        dayWorkTime: '', //1일 작업시간
        dayRestTime1: '',
        dayRestTime2: '',
        prevWork: '', //현작업 이전에 하던 작업
        prevPeriod1: '',
        prevPeriod2: '',
      }
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .title {
    font-size: 0.9rem;
    font-weight: 500;
  }

  .mb-4 {
    margin-bottom: 1rem !important;
  }

  vs-row {
    margin-bottom: 0.75rem;
  }

  /* 제목 영역 */
  h5 {
    font-size: 1rem !important;
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    padding-left: 0.25rem;
  }

  /* 모바일에서 좌우 패딩 추가 */
  .grid.flex-wrap {
    padding: 0 0.25rem;
  }

  /* 입력 필드 간격 개선 */
  vs-row.mb-4 {
    margin-bottom: 1.25rem !important;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.75rem;
  }

  /* 라디오 버튼 그룹 정렬 */
  .vs-radio {
    height: 2rem;
    display: flex;
    align-items: center;
  }

  /* 입력 필드 스타일 */
  .ml-input {
    margin-top: 0.25rem;
  }

  /* 연속된 필드 사이 간격 개선 */
  .w-full.grid {
    row-gap: 0.5rem;
    margin-top: 0.25rem;
  }
}
</style>
